// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__384ji","load2":"Spinner_load2__2wl9R"};